"use client"

import * as React from "react"
import { KeyMetrics } from "@/components/key-metrics"
import { TermKanban } from "./term-kanban"
import { TermsAnalysisSection } from "./terms-analysis-section"
import type { EvaluationTerm } from "@/lib/mock/evaluation-dashboard"
import { EVAL_DASHBOARD_KPI_STRIP_CLASS } from "@/lib/evaluation-dashboard-a11y"
import { evaluationDashboardKpiMetrics } from "@/lib/mock/evaluation-dashboard-kpi"

interface EvaluationDashboardLifecycleViewProps {
  showNoTerms: boolean
  currentTerm?: EvaluationTerm
  lastTerm?: EvaluationTerm
  pastTerms: EvaluationTerm[]
  upcomingTerms: EvaluationTerm[]
  futureTerms: EvaluationTerm[]
}

export function EvaluationDashboardLifecycleView({
  showNoTerms,
  currentTerm,
  lastTerm,
  pastTerms,
  upcomingTerms,
  futureTerms,
}: EvaluationDashboardLifecycleViewProps) {
  const metrics = React.useMemo(
    () => evaluationDashboardKpiMetrics(currentTerm, lastTerm),
    [currentTerm, lastTerm],
  )

  return (
    <div className="flex flex-col gap-10">
      <KeyMetrics
        variant="cards"
        size="md"
        metrics={metrics}
        showHeader={false}
        metricsSingleRow
        className={EVAL_DASHBOARD_KPI_STRIP_CLASS}
      />

      <TermKanban
        currentTerm={currentTerm}
        lastTerm={lastTerm}
        showNoTerms={showNoTerms}
      />

      {!showNoTerms ? (
        <TermsAnalysisSection
          pastTerms={pastTerms}
          upcomingTerms={upcomingTerms}
          futureTerms={futureTerms}
        />
      ) : null}
    </div>
  )
}
